import React, { useState, useCallback, useEffect } from "react";
import { Paper, Typography, InputAdornment, TextField } from "@mui/material";
import { FaLocationDot } from "react-icons/fa6";
import GraphDashboardActions from "../../Actions/GraphDashboardActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { apiPayloadCreation } from "../Dashboard/MuiCharts/DashBoardHelperFunction";
import { useSelectedPlantActionContext } from "../../Context/GlobalContext";
import SearchIcon from "@mui/icons-material/Search";
import { useLanguageContext } from "../../Context/LanguageContext";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import commonUtils from "../../helpers/commonUtils";
import AppConstants from "../../Constants/AppConstants";

export default function GraphSidebar({ equipmentGrpResponse }) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const updatePlant = useSelectedPlantActionContext();
  const [selectedPlantId, setSelectedPlantId] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State to hold search input
  const [filteredPlants, setFilteredPlants] = useState([]); // State for filtered list

  const handleClick = useCallback(
    (_plantId) => {
      sessionStorage.setItem("werkId", _plantId);
      updatePlant(_plantId);
      setGlobalSpinner(true);
      setSelectedPlantId(_plantId); // Correctly set selectedPlantId

      const payLoad = apiPayloadCreation(30, _plantId);

      GraphDashboardActions.getInspectionKpiDat(payLoad);
      GraphDashboardActions.getDashboardEquipmentStatusDistribution(payLoad);
      GraphDashboardActions.getTicketKpiData(payLoad);
      EquipmentGroupActions.getPlantEquipmentGroups(_plantId);
      if (commonUtils.isUserOrganisationAdmin()) {
        GraphDashboardActions.getOrganisationKpiData(payLoad);
      }
      if (
        commonUtils.isUserOrganisationAdmin() &&
        sessionStorage.getItem("dashboardTabValue") === "2"
      ) {
        payLoad["PlantId"] = AppConstants.DEFAULT_GUID;
      }
      GraphDashboardActions.getDashboardSummaryData(payLoad);
    },
    [setGlobalSpinner, updatePlant]
  );

  // Filter plant list when search query or equipment group response changes
  useEffect(() => {
    if (equipmentGrpResponse?.plantNameList) {
      const filtered = equipmentGrpResponse.plantNameList.filter((item) =>
        item.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredPlants(filtered);
    }
  }, [searchQuery, equipmentGrpResponse]);

  // Automatically select the first plant on first render
  useEffect(() => {
    if (
      equipmentGrpResponse?.plantNameList?.length &&
      !selectedPlantId // Ensure this runs only if no plant is selected
    ) {
      const firstPlantId =
        equipmentGrpResponse.response[
          equipmentGrpResponse.plantNameList[0]
        ]?.[0]?.werk;
      if (firstPlantId) {
        setSelectedPlantId(firstPlantId); // Highlight the first plant
        handleClick(firstPlantId); // Load data for the first plant
      }
    }
  }, [equipmentGrpResponse, handleClick, selectedPlantId]);

  return (
    equipmentGrpResponse && (
      <div className="sidebar-header">
        <Typography className="sideBarHeader">{localization.plant}</Typography>
        <TextField
          className="sideBarSearchCls"
          placeholder={localization.search}
          variant="outlined"
          autoFocus={true}
          fullWidth
          margin="normal"
          value={searchQuery} // Bind search input to state
          onChange={(e) => setSearchQuery(e.target.value)} // Update search state
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className="searchIconCls" />
              </InputAdornment>
            ),
          }}
        />
        {filteredPlants.map((item, index) => {
          const plantId = equipmentGrpResponse.response[item]?.[0]?.werk;
          const display_plant_id =
            equipmentGrpResponse.response[item]?.[0]?.plantId;
          return (
            <Paper
              key={index}
              className={
                selectedPlantId === plantId
                  ? "graphSideBarStyle graphSideBarStyleClick"
                  : "graphSideBarStyle"
              }
              onClick={() => handleClick(plantId)}
            >
              <Typography className="graphSideBarTextStyle">
                <FaLocationDot
                  className={`${
                    selectedPlantId === plantId ? "svgIconSelected" : "svgIcon"
                  } mr-3`}
                />
                {display_plant_id + "-" + item}
              </Typography>
            </Paper>
          );
        })}
      </div>
    )
  );
}
